import React from 'react';
import { Quote } from 'lucide-react';

const SocialProofSection = () => {
  return (
    <section 
      className="py-20 relative overflow-hidden"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1565891741441-64926e441838)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 to-gray-900/95"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Join companies optimizing their returnable packaging operations
          </p>
        </div>

        {/* Testimonial */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-12 border border-white/20 shadow-2xl">
            <Quote className="w-12 h-12 text-red-400 mb-6" />
            <blockquote className="text-2xl text-white font-medium leading-relaxed mb-8">
              "E2-Return transformed our returnable packaging operations. We reduced losses by 75% and improved asset rotation speed by 40% within the first three months. The deployment was incredibly fast, and the ROI was immediate."
            </blockquote>
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center text-white font-bold text-xl">
                JD
              </div>
              <div>
                <p className="text-white font-bold text-lg">John Doe</p>
                <p className="text-gray-300">Supply Chain Director, Manufacturing Company</p>
              </div>
            </div>
          </div>
        </div>

        {/* Placeholder Logos */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-12 opacity-60">
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="w-32 h-16 bg-white/20 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">Logo {item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
